import { computed, Injectable, Signal, signal, WritableSignal } from '@angular/core';

/** Claim in a field initializer or constructor, never later: components are instantiated before `NavigationEnd`, and claiming any later would let the overlay release first. */
@Injectable({
  providedIn: 'root',
})
export class BootLoaderService {
  #pendingClaims: WritableSignal<number> = signal(0);

  isContentPending: Signal<boolean> = computed(() => this.#pendingClaims() > 0);

  /** The release function is idempotent and safe to call from several places — a page typically releases both when its content lands and on destroy, whichever comes first. */
  claim(): () => void {
    this.#pendingClaims.update((count: number) => count + 1);

    let released = false;

    return () => {
      if (released) {
        return;
      }

      released = true;
      this.#pendingClaims.update((count: number) => Math.max(0, count - 1));
    };
  }

  /** Escape hatch for the app-level safety cap: a stuck claim must never strand the overlay. */
  releaseAll(): void {
    this.#pendingClaims.set(0);
  }
}
